import React from 'react';
import { Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import TopAlignCheckbox from 'components/topAlignCheckbox/TopAlignCheckbox';
import './TermsSection.scss';
import TermsAndConditionsField from 'components/termsAndConditionsField/TermsAndConditionsField';
import LinkButton from 'components/linkButton/LinkButton';
import { buildPolicyPath, buildTermsPath } from 'utils/pathBuilder';

interface TermsSectionProps {
  isReadonly?: boolean;
}

const TermsSection: React.FC<TermsSectionProps> = ({ isReadonly = false }) => {
  const { t } = useTranslation('registration');

  const handleInfoClick = () => {
    const url = t('personalInfoLink');
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handlePrivacyPolicyClick = () => {
    window.open(buildPolicyPath(), '_blank', 'noopener,noreferrer');
  };

  const handleTermsClick = () => {
    window.open(buildTermsPath(), '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="terms-section-container">
      <div className="vls-section-title">
        {!isReadonly
          ? t('termsAndConditionsTitle')
          : t('serviceTermsAndConditions')}
      </div>

      {!isReadonly && (
        <>
          {/* Personal Information Collection Statement */}
          <div className="section-subtitle">
            {t('personalInfoCollectionStatement')}
          </div>

          <div className="terms-content">
            {t('personalInfoCollectionText')}{' '}
            <LinkButton
              onClick={handleInfoClick}
              title={t('personalInfoCollectionLink')}
            />
          </div>

          <Divider className="section-divider" />

          <div className="section-subtitle">
            {t('serviceTermsAndConditions')}
          </div>
        </>
      )}

      {/* Service Terms and Conditions */}

      <Form.Item
        name="agreeTerms"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) => {
              if (value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t('agreeTermsRequired')));
            },
          },
        ]}
      >
        {isReadonly ? (
          <TermsAndConditionsField isReadonly={true} />
        ) : (
          <TopAlignCheckbox>
            <TermsAndConditionsField
              isReadonly={false}
              onPrivacyPolicyClick={handlePrivacyPolicyClick}
              onTermsClick={handleTermsClick}
            />
          </TopAlignCheckbox>
        )}
      </Form.Item>
    </div>
  );
};

export default TermsSection;